import * as React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process, State, DataResult } from "@progress/kendo-data-query"
import "@progress/kendo-theme-material/dist/all.css";
import { UiSwitch } from "../../../../../_uiComponents/telerikComponents/UiSwitch";
import { UiButton } from "../../../../../_uiComponents/common/form/UiButton";

const initialDataState = {
    skip: 0,
    take: 3,
};

const initialSort = [
    {
        field: "rewardName",
        dir: "asc",
    },
];

const GamePlayRewardPotConfiguration = ({ allocatedRewards = [] }) => {
    const [page, setPage] = React.useState(initialDataState);
    const [sort, setSort] = React.useState(initialSort);
    const [pageSizeValue, setPageSizeValue] = React.useState();
    const [dataState, setDataState] = React.useState();
    const [rewards, setRewards] = React.useState(allocatedRewards);
    const [resultState, setResultState] = React.useState(
        process(rewards, initialDataState)
    );
    const [editingRows, setEditingRows] = React.useState({});

    React.useEffect(() => {
        setRewards(allocatedRewards);
        setResultState(process(allocatedRewards, dataState || initialDataState));
    }, [allocatedRewards]);

    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        setResultState(process(rewards, event.page.skip, event.page.take));
        const take =
            targetEvent.value === "All" ? rewards.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const onDataStateChange = React.useCallback((e) => {
        setDataState(e.dataState);
        setSort(e.sort);
        setResultState(process(rewards, e.dataState));
    }, [rewards]);

    const handleAllocatedQtyChange = (rowId, value) => {
        setEditingRows(prev => ({
            ...prev,
            [rowId]: value
        }));
    };

    const handleSaveAllocatedQty = (rowId) => {
        const newValue = editingRows[rowId];
        if (newValue !== undefined) {
            // Update the rewards array
            const updatedRewards = rewards.map(reward => 
                reward.id === rowId 
                    ? { 
                        ...reward, 
                        allocatedQty: parseInt(newValue, 10),
                        remainingQty: parseInt(newValue, 10) - reward.issuedQty
                    }
                    : reward
            );
            
            setRewards(updatedRewards);
            setResultState(process(updatedRewards, { skip: page.skip, take: page.take }));
            
            // Clear the editing state for this row
            setEditingRows(prev => {
                const newState = { ...prev };
                delete newState[rowId];
                return newState;
            });

            console.log(`Saved allocated quantity for row ${rowId}: ${newValue}`);
            // Add your API call here to save the data
        }
    };

    const AllocatedQtyCell = (props) => {
        const rowId = props.dataItem.id;
        const currentValue = editingRows[rowId] !== undefined ? editingRows[rowId] : props.dataItem.allocatedQty;
        
        return (
            <td {...props.tdProps} className="sba-telerik-grid-input">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                        type="number"
                        value={currentValue}
                        onChange={(e) => handleAllocatedQtyChange(rowId, e.target.value)}
                        style={{
                            width: '80px',
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px'
                        }}
                    />
                    <UiButton
                        name="Save"
                        variant="contained"
                        size="small"
                        onClick={() => handleSaveAllocatedQty(rowId)}
                        disabled={editingRows[rowId] === undefined}
                    />
                </div>
            </td>
        );
    };

    const WinningCell = (props) => {
        const { dataItem } = props;
        
        return (
            <td
                {...props.tdProps}
                className="sba-telerik-grid-button"
            >
                <UiSwitch checked={!dataItem.excludeWinning} />
            </td>
        );
    };

    const ActiveCell = (props) => {
        const { dataItem } = props;
        
        return (
            <td
                {...props.tdProps}
                className="sba-telerik-grid-button"
            >
                <UiSwitch checked={dataItem.isActive} />
            </td>
        );
    };

    return (
        <div className='sba-telerik-components-wr'>
            <Grid
                data={resultState.data || []}
                skip={page.skip}
                take={page.take}
                total={rewards.length}
                sortable={true}
                fixedScroll={true}
                sort={sort}
                {...dataState}
                onPageChange={pageChange}
                onDataStateChange={onDataStateChange}
            >
                <GridColumn field="rewardName" title="Reward Name" width="200px"/>
                <GridColumn field="rewardValueInGbp" title="Reward Value (£)" width="200px"/>
                <GridColumn field="allocatedQty" title="Allocated Qty" width="250px" cells={{
                    data: AllocatedQtyCell
                }} />
                <GridColumn field="issuedQty" title="Issued Qty" width="200px"/>
                <GridColumn field="remainingQty" title="Remaining Qty" width="200px"/>
                <GridColumn field="excludeWinning" title="Winning Item" width="150px" cells={{
                    data: WinningCell
                }} />
                <GridColumn field="isActive" title="Active" width="100px" cells={{
                    data: ActiveCell
                }} />
            </Grid>
        </div>
    );
};

export default GamePlayRewardPotConfiguration;